// Copyright (c) StrangeBee 2023

import React, { ReactElement, useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import LiveStream from '@Organisms/LiveStream';
import client from '@Client';
import useOneQuery from '@Hooks/useOneQuery';
import { CaseOutput, SeverityValues, BrandingParams } from 'thehive-sdk';
import { getAvatarUrl } from '@Helpers/images';
import CaseNumber from '@Organisms/Case/CaseNumber/CaseNumber';
import { computeGetSelector } from '@Organisms/Case/selector';
import { useStreamObserver } from '@Hooks/useStream';
import { STREAM_EVENTS } from '@Services/StreamSrv';

import './LiveDetailsPage.scss';
import { StreamContext } from '@Context/StreamProvider';

interface LiveFeedPageProps {
    brandingData?: BrandingParams;
}

const LiveFeedPage = ({ brandingData }: LiveFeedPageProps): ReactElement | null => {
    const { caseId } = useParams<{ caseId: string }>();
    const [titleCase, setTitleCase] = useState('');
    const [severityCase, setSeverityCase] = useState<SeverityValues>(1);
    const { streamReady } = useContext(StreamContext);

    const { data: caseData } = useOneQuery<CaseOutput>({
        selector: computeGetSelector({ caseId }),
        controller: client.CaseController,
    });

    const { number: caseNumber = 0 } = caseData || {};

    useStreamObserver({ rootId: caseId, objectType: STREAM_EVENTS.CASE }, (data) => {
        data.forEach(({ base }) => {
            if (base.action === 'update' && (base.object as CaseOutput)._id === caseId) {
                const { title, severity } = base.object as CaseOutput;
                title && setTitleCase(title);
                severity && setSeverityCase(severity);
            }
        });
    });

    useEffect(() => {
        if (caseData) {
            const { title, severity } = caseData;
            setTitleCase(title);
            setSeverityCase(severity as SeverityValues);
        }
    }, [caseData]);

    return caseId ? (
        <div className="window-details">
            <div className="window-details_header">
                <img
                    className="window-details_header-logo"
                    src={brandingData?.menuLogo ? getAvatarUrl(brandingData.menuLogo) : `static/images/logo.bee.svg`}
                    alt="logo"
                />
                <CaseNumber
                    caseNumber={caseNumber}
                    className="window-details_header-number"
                    severity={severityCase}
                    hashtag
                    fillType={'fill'}
                />
                <div className="window-details_header-title">{titleCase}</div>
            </div>

            <LiveStream caseId={caseId} streamReady={streamReady} />
        </div>
    ) : null;
};
export default LiveFeedPage;
